// quantity-bundle.js
// Funcionalidade para o Bundle de Quantidade

class QuantityBundle {
  constructor(container) {
    this.container = container;
    this.productId = container.dataset.productId;
    this.variantId = container.dataset.variantId;
    this.variantAvailable = container.dataset.variantAvailable === 'true';
    this.productHandle = container.dataset.productHandle;

    // Debug: mostrar dados capturados do HTML
    console.log('🔧 QuantityBundle inicializado:', {
      productId: this.productId,
      variantId: this.variantId,
      variantAvailable: this.variantAvailable,
      productHandle: this.productHandle
    });
    this.radioButtons = container.querySelectorAll('.quantity-bundle__radio');
    this.buyButton = container.querySelector('.quantity-bundle__buy-button');
    this.comparePriceEl = container.querySelector('.quantity-bundle__compare-price');
    this.comparePriceTextEl = container.querySelector('.quantity-bundle__compare-price-text');
    this.currentPriceEl = container.querySelector('.quantity-bundle__current-price');
    this.pixPriceEl = container.querySelector('.quantity-bundle__pix-price');

    // Capturar quantidade da opção 3 (1 unidade) para esconder preço de comparação
    this.option3Quantity = parseInt(container.dataset.option3Quantity) || 1;
    
    this.baseComparePrice = parseFloat(this.comparePriceEl.dataset.comparePrice) / 100;
    this.baseCurrentPrice = parseFloat(this.currentPriceEl.dataset.currentPrice) / 100;
    this.pixDiscount = parseFloat(this.pixPriceEl.dataset.pixDiscount) || 1;
    
    // Capturar descontos por quantidade - versão dinâmica para Horizon
    this.quantityDiscounts = {};
    
    // Capturar dados dinamicamente de cada opção disponível
    const options = this.container.querySelectorAll('.quantity-bundle__option');
    options.forEach(option => {
      const quantity = parseInt(option.dataset.quantity);
      if (quantity) {
        // Determinar qual opção é baseado na ordem
        const optionIndex = Array.from(options).indexOf(option) + 1;
        const discountAttr = `option${optionIndex}Discount`;
        const discountValue = parseFloat(
          container.dataset[discountAttr] || 
          container.getAttribute(`data-option-${optionIndex}-discount`)
        ) || 0;
        
        this.quantityDiscounts[quantity] = discountValue;
      }
    });
    
    // Debug temporário - remover em produção
    // console.log('Mapeamento dinâmico de descontos:', this.quantityDiscounts);
    
    this.selectedQuantity = this.getSelectedQuantity();
    
    this.init();
  }

  init() {
    this.bindEvents();
    this.updatePrices();
    this.setupButton();
  }

  debugDiscounts() {
    // Debug para verificar se os descontos estão sendo capturados corretamente
    console.log('=== DEBUG QUANTITY BUNDLE ===');
    console.log('Container dataset completo:', this.container.dataset);
    console.log('option1Discount:', this.container.dataset.option1Discount);
    console.log('option2Discount:', this.container.dataset.option2Discount);
    console.log('option3Discount:', this.container.dataset.option3Discount);
    console.log('Descontos capturados:', this.quantityDiscounts);
    console.log('Preço base:', this.baseCurrentPrice);
    console.log('=============================');
  }

  setupButton() {
    // Salvar o texto e estilo original do botão
    this.originalButtonText = this.buyButton.textContent;
    this.originalButtonStyle = this.buyButton.style.background;
  }

  bindEvents() {
    // Event listener para mudança de quantidade
    this.radioButtons.forEach(radio => {
      radio.addEventListener('change', (e) => {
        this.selectedQuantity = parseInt(e.target.value);
        this.updatePrices();
        this.updateVisualSelection();
      });
    });

    // Event listener para botão de compra
    this.buyButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.addToCart();
    });

    // Event listener para clique nas opções
    this.container.querySelectorAll('.quantity-bundle__option').forEach(option => {
      option.addEventListener('click', (e) => {
        if (e.target.type !== 'radio') {
          const radio = option.querySelector('.quantity-bundle__radio');
          if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change'));
          }
        }
      });
    });
  }

  getSelectedQuantity() {
    const checkedRadio = this.container.querySelector('.quantity-bundle__radio:checked');
    return checkedRadio ? parseInt(checkedRadio.value) : 1;
  }

  updatePrices() {
    const quantity = this.selectedQuantity;
    
    // Obter desconto para a quantidade selecionada
    const quantityDiscountPercent = this.quantityDiscounts[quantity] || 0;
    const quantityDiscountDecimal = quantityDiscountPercent / 100;
    
    // Calcular preços totais
    const totalComparePrice = this.baseComparePrice * quantity;
    const totalCurrentPriceBeforeDiscount = this.baseCurrentPrice * quantity;
    
    // Aplicar desconto por quantidade
    const totalCurrentPrice = totalCurrentPriceBeforeDiscount * (1 - quantityDiscountDecimal);
    
    // Aplicar desconto do Pix em cima do preço já com desconto de quantidade
    const pixDiscountDecimal = this.pixDiscount / 100;
    const totalPixPrice = totalCurrentPrice * (1 - pixDiscountDecimal);

    // Atualizar elementos no DOM
    this.comparePriceEl.textContent = this.formatPrice(totalComparePrice);
    this.currentPriceEl.textContent = this.formatPrice(totalCurrentPrice);

    // Esconder preço de comparação quando opção 3 estiver selecionada
    this.updateComparePriceVisibility();

    // Atualizar preço do Pix mantendo o texto original
    const pixText = this.pixPriceEl.textContent.split(' ').slice(-2).join(' '); // Pega "no pix"
    this.pixPriceEl.innerHTML = `${this.formatPrice(totalPixPrice)} ${pixText}`;
  }

  updateVisualSelection() {
    // Remove seleção visual de todas as opções
    this.container.querySelectorAll('.quantity-bundle__option').forEach(option => {
      option.classList.remove('quantity-bundle__option--selected');
    });

    // Adiciona seleção visual à opção ativa
    const selectedRadio = this.container.querySelector('.quantity-bundle__radio:checked');
    if (selectedRadio) {
      const selectedOption = selectedRadio.closest('.quantity-bundle__option');
      selectedOption.classList.add('quantity-bundle__option--selected');
    }
  }

  formatPrice(price) {
    return 'R$' + price.toFixed(2).replace('.', ',');
  }

  updateComparePriceVisibility() {
    // Verificar qual radio está selecionado (pelo id que termina com -1, -2 ou -3)
    const selectedRadio = this.container.querySelector('.quantity-bundle__radio:checked');
    if (!selectedRadio) return;

    // Pegar o índice da opção pelo id (quantity-xxx-1, quantity-xxx-2, quantity-xxx-3)
    const radioId = selectedRadio.id;
    const isOption3 = radioId.endsWith('-3');

    // Esconder preço de comparação quando opção 3 estiver selecionada
    if (isOption3) {
      this.comparePriceEl.style.display = 'none';
      if (this.comparePriceTextEl) {
        this.comparePriceTextEl.style.display = 'none';
      }
    } else {
      this.comparePriceEl.style.display = '';
      if (this.comparePriceTextEl) {
        this.comparePriceTextEl.style.display = '';
      }
    }
  }

  async addToCart() {
    // Prevenir múltiplas execuções
    if (this.buyButton.disabled) return;

    // Debug inicial
    console.log('🔍 Debug inicial:', {
      variantId: this.variantId,
      variantAvailable: this.variantAvailable,
      productId: this.productId,
      productHandle: this.productHandle,
      container: this.container.dataset
    });

    try {
      this.buyButton.disabled = true;
      this.buyButton.textContent = 'Adicionando...';

      // Sempre buscar dados atualizados do produto via API para garantir disponibilidade
      let variantId = this.variantId;
      let variantAvailable = this.variantAvailable;

      // Buscar dados frescos do produto para verificar disponibilidade real
      console.log('🔄 Buscando dados atualizados do produto...');
      const productData = await this.fetchProductData();
      console.log('📦 Dados do produto via API:', productData);

      if (productData && productData.variants && productData.variants.length > 0) {
        // Procurar primeira variante disponível
        const availableVariant = productData.variants.find(v => v.available);

        if (availableVariant) {
          variantId = availableVariant.id;
          variantAvailable = true;
          console.log('✅ Variante disponível encontrada:', availableVariant.id, availableVariant.title);
        } else {
          // Todas as variantes esgotadas
          console.log('❌ Nenhuma variante disponível encontrada');
          throw new Error('Produto esgotado. Todas as variantes estão indisponíveis.');
        }
      } else if (!variantId || variantId === 'undefined' || variantId === '') {
        throw new Error('Produto não encontrado ou sem variantes disponíveis');
      }

      // Preparar dados do carrinho
      const cartData = {
        id: variantId,
        quantity: this.selectedQuantity
      };

      // Debug: mostrar dados sendo enviados
      console.log('🛒 Tentando adicionar ao carrinho:', {
        variantId: variantId,
        quantity: this.selectedQuantity,
        productHandle: this.productHandle,
        cartData: cartData
      });

      // Adicionar ao carrinho
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(cartData)
      });

      // Debug: mostrar resposta
      const responseText = await response.text();
      console.log('📦 Resposta do carrinho:', {
        status: response.status,
        ok: response.ok,
        body: responseText
      });

      if (response.ok) {
        const responseData = JSON.parse(responseText);

        // Sucesso - mostrar feedback
        this.showSuccessFeedback();

        // Buscar estado atual do carrinho
        const cartState = await this.getCartState();

        // Trigger evento correto do Horizon
        this.triggerHorizonCartUpdate(cartState);

        // Backup: tentar atualizar cart-items-component diretamente
        this.updateCartItemsComponent();

        // Abrir drawer do carrinho após um delay maior para processar eventos
        setTimeout(() => {
          this.openCartDrawer();
        }, 500);

      } else {
        const errorData = responseText ? JSON.parse(responseText) : {};
        console.error('❌ Erro do Shopify:', errorData);
        throw new Error(errorData.description || 'Erro ao adicionar produto ao carrinho');
      }

    } catch (error) {
      console.error('Erro:', error);
      this.showErrorFeedback();
    }
  }

  async fetchProductData() {
    // Primeiro tentar usar o handle do data attribute
    if (this.productHandle) {
      const response = await fetch(`/products/${this.productHandle}.js`);
      if (response.ok) {
        return await response.json();
      }
    }

    // Fallback: buscar dados do produto via ShopifyAnalytics
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      return window.ShopifyAnalytics.meta.product;
    }

    // Fallback: buscar via handle na URL
    const handle = this.getProductHandle();
    if (handle) {
      const response = await fetch(`/products/${handle}.js`);
      return await response.json();
    }

    throw new Error('Não foi possível obter dados do produto');
  }

  getProductHandle() {
    // Tentar obter o handle do produto da URL
    const path = window.location.pathname;
    const match = path.match(/\/products\/([^\/]+)/);
    return match ? match[1] : null;
  }

  showSuccessFeedback() {
    this.buyButton.textContent = '✓ Adicionado!';
    this.buyButton.style.background = '#4CAF50';
    
    // Restaurar botão após 2 segundos
    setTimeout(() => {
      this.restoreButton();
    }, 2000);
  }

  showErrorFeedback() {
    this.buyButton.textContent = 'Erro - Tente novamente';
    this.buyButton.style.background = '#f44336';
    
    // Restaurar botão após 3 segundos
    setTimeout(() => {
      this.restoreButton();
    }, 3000);
  }

  restoreButton() {
    this.buyButton.disabled = false;
    this.buyButton.textContent = this.originalButtonText;
    this.buyButton.style.background = this.originalButtonStyle || '';
  }

  restoreButton() {
    this.buyButton.disabled = false;
    this.buyButton.textContent = this.originalButtonText;
    this.buyButton.style.background = this.originalButtonStyle || '';
  }

  async getCartState() {
    try {
      const response = await fetch('/cart.js');
      return await response.json();
    } catch (error) {
      console.error('Erro ao buscar estado do carrinho:', error);
      return null;
    }
  }

  triggerHorizonCartUpdate(cartState) {
    if (!cartState) return;

    const eventData = {
      data: {
        itemCount: cartState.item_count,
        source: 'quantity-bundle-component',
        cart: cartState
      }
    };

    // Lista de possíveis nomes de eventos do Horizon
    const eventVariations = [
      'theme:cart-update',
      'cart:update',
      'cartUpdate', 
      'cart-update',
      'ThemeEvents.cartUpdate'
    ];

    try {
      // Tentar todos os possíveis nomes de eventos
      eventVariations.forEach(eventName => {
        const event = new CustomEvent(eventName, {
          detail: eventData,
          bubbles: true
        });
        
        document.dispatchEvent(event);
      });
      
      console.log('✅ Eventos de carrinho disparados com sucesso');

    } catch (error) {
      console.error('Erro ao disparar evento do Horizon:', error);
    }
  }

  updateCartItemsComponent() {
    try {
      const cartItemsComponent = document.querySelector('cart-items-component');
      if (cartItemsComponent) {
        // Tentar vários métodos possíveis
        if (typeof cartItemsComponent.refresh === 'function') {
          cartItemsComponent.refresh();
        } else if (typeof cartItemsComponent.updateCart === 'function') {
          cartItemsComponent.updateCart();
        } else if (typeof cartItemsComponent.render === 'function') {
          cartItemsComponent.render();
        } else {
          // Força re-render removendo e adicionando o componente
          const parent = cartItemsComponent.parentNode;
          const nextSibling = cartItemsComponent.nextSibling;
          parent.removeChild(cartItemsComponent);
          parent.insertBefore(cartItemsComponent, nextSibling);
        }
      }
    } catch (error) {
      console.error('Erro ao atualizar cart-items-component:', error);
    }
  }

  openCartDrawer() {
    // Versão para Horizon theme
    const cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer) {
      // Tentar método open() primeiro
      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
        return;
      }
      
      // Fallback: tentar showDialog() diretamente
      if (typeof cartDrawer.showDialog === 'function') {
        cartDrawer.showDialog();
        return;
      }
      
      // Fallback: simular clique no botão de abertura
      const openButton = cartDrawer.querySelector('button[on\\:click="/open"]');
      if (openButton) {
        openButton.click();
        return;
      }
    }

    // Fallback para Dawn theme
    const cartDrawerDawn = document.querySelector('cart-drawer');
    if (cartDrawerDawn && typeof cartDrawerDawn.open === 'function') {
      cartDrawerDawn.open();
      return;
    }

    // Fallback final: trigger do ícone do carrinho
    const cartIcon = document.querySelector('#cart-icon-bubble, [data-cart-toggle], cart-icon');
    if (cartIcon) {
      cartIcon.click();
    }
  }
}

// Inicialização quando o DOM estiver pronto
function initQuantityBundles() {
  const bundles = document.querySelectorAll('.quantity-bundle');
  bundles.forEach(bundle => {
    new QuantityBundle(bundle);
  });
}

// Auto-inicializar
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initQuantityBundles);
} else {
  initQuantityBundles();
}

// Re-inicializar quando seções forem carregadas dinamicamente (Theme Editor)
document.addEventListener('shopify:section:load', (event) => {
  const section = event.target;
  const bundles = section.querySelectorAll('.quantity-bundle');
  bundles.forEach(bundle => {
    new QuantityBundle(bundle);
  });
});

// Limpar quando seções forem removidas
document.addEventListener('shopify:section:unload', (event) => {
  // Cleanup se necessário (event listeners são automaticamente removidos quando elementos são removidos do DOM)
});

// Exportar para uso global se necessário
window.QuantityBundle = QuantityBundle;

// Inicialização quando o DOM estiver pronto
function initQuantityBundles() {
  const bundles = document.querySelectorAll('.quantity-bundle');
  bundles.forEach(bundle => {
    new QuantityBundle(bundle);
  });
}

// Auto-inicializar
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initQuantityBundles);
} else {
  initQuantityBundles();
}

// Re-inicializar quando seções forem carregadas dinamicamente (Theme Editor)
document.addEventListener('shopify:section:load', (event) => {
  const section = event.target;
  const bundles = section.querySelectorAll('.quantity-bundle');
  bundles.forEach(bundle => {
    new QuantityBundle(bundle);
  });
});

// Limpar quando seções forem removidas
document.addEventListener('shopify:section:unload', (event) => {
  // Cleanup se necessário (event listeners são automaticamente removidos quando elementos são removidos do DOM)
});

// Exportar para uso global se necessário
if(!window.QuantityBundle) window.QuantityBundle = QuantityBundle;
